/**
 * Piagnet - Multi-channel AI Gateway
 *
 * Piagnet is a multi-channel AI gateway that allows AI agents to communicate
 * through various messaging platforms (Telegram, Discord, Slack, etc.) and
 * provides a web-based management interface.
 *
 * @module piagnet
 */

export { AgentRunner } from "./agent/runner.js";
export { SandboxManager } from "./agent/sandbox.js";
export { ToolPolicyResolver } from "./agent/tools.js";
// Agent exports
export type {
	AgentContext,
	AgentRunnerConfig,
	SandboxConfig,
	ToolPolicy,
} from "./agent/types.js";
export { ConfigManager } from "./config/manager.js";
// Config exports
export type {
	AccessControlPolicy,
	AgentDefinition,
	ChannelBinding,
	PiagnetConfig,
} from "./config/schema.js";
// Channel exports
export type {
	ChannelAdapter,
	ChannelConfig,
	ChannelMonitor,
	ChannelProfile,
	ChannelScope,
} from "./gateway/channels/base.js";
// Channel adapter exports
export { TelegramAdapter } from "./gateway/channels/telegram.js";
export { DiscordAdapter, DiscordIntents } from "./gateway/channels/discord.js";
export { SlackAdapter } from "./gateway/channels/slack.js";
export { MessageRouter } from "./gateway/router.js";
export { Gateway } from "./gateway/server.js";
export { SessionManager } from "./gateway/sessions.js";
// Gateway exports
export type {
	GatewayConfig,
	GatewayServer,
	InboundMessage,
	OutboundMessage,
	RouteResolution,
	Session,
	SessionKey,
	WebSocketConnection,
} from "./gateway/types/index.js";

// Version
export const VERSION = "0.51.6";
